import React from 'react';
import { Link } from 'react-router-dom';
import {
  NavItem,
  NavLink,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { getSetting } from '../helpers/Settings';

const SupportLink = () => {
  const intl = useIntl();

  if (!getSetting('cs1')) {
    return null;
  }

  return (
    <NavItem>
      <NavLink
        id="support-icon"
        to="/content/how-to"
        tag={Link}
      >
        <i className="fal fa-question-circle" />
      </NavLink>
      <UncontrolledTooltip fade={false} placement="bottom" target="support-icon">
        {intl.formatMessage({ defaultMessage: 'Support' })}
      </UncontrolledTooltip>
    </NavItem>
  );
};

export default SupportLink;
